import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit';
import type { SubscriptionStatusResponse } from "@service/subscriptionApi";

export interface SubscriptionState {
    status: string | null;
    plan: string | null;
    allowedCredits: number;
    remainingCredits: number;
    hasSubscription: boolean | undefined;
    isPilotMember: "active" | "completed" | "forfeited" | null;
}

const initialState: SubscriptionState = {
    status: null,
    plan: null,
    allowedCredits: 0,
    remainingCredits: 0,
    hasSubscription: undefined,
    isPilotMember: null
};

const subscriptionSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {
        setSubscription: (
            state,
            action: PayloadAction<SubscriptionStatusResponse>
        ) => {
            state.status = action.payload.subscription.status;
            state.plan = action.payload.plan.name;
            state.allowedCredits = Number(action.payload.credits.total_allocated);
            state.remainingCredits = Number(action.payload.credits.remaining);
            state.isPilotMember =  action.payload.subscription.founder_offer_status;
        },

        clearSubscription: (state) => {
            state.status = null;
            state.plan = null;
            state.remainingCredits = 0;
        },

        updateCredits: (state, action: PayloadAction<number>) => {
            state.remainingCredits = action.payload;
        },

        setHasSubscription: (state, action: PayloadAction<boolean>) => {
            state.hasSubscription = action.payload;
        },
    },
});

export const {
    setSubscription,
    clearSubscription,
    updateCredits,
    setHasSubscription,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;